// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"391":"c34c51f5","695":"b3b87394"}[chunkId] + ".chunk.css";
};